import Vue from "vue";
import Vuex from "vuex";
import { CONFIG } from "./config-defaults";
import IAvatar from "./typings/IAvatar";
import IConfig from "./typings/IConfig";
import IQuestion from "./typings/IQuestion";
import IResponse from "./typings/IResponse";

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    addResponse({ commit }, response: IResponse): void {
      commit("ADD_RESPONSE", response);
    },

    decrementProgress({ commit }): void {
      commit("DECREMENT_PROGRESS");
    },

    incrementProgress({ commit }): void {
      commit("INCREMENT_PROGRESS");
    },

    populateDeck({ commit, state }): void {
      commit("UPDATE_DECK", state.questions);
      commit("UPDATE_UNIT_PROGRESS", state);
    },

    resetState({ commit }): void {
      commit("RESET_STATE");
    },

    shuffleDeck({ commit, state }): void {
      commit("UPDATE_DECK", state.questions);
      commit("UPDATE_UNIT_PROGRESS", state);
    },

    undoResponse({ commit }): void {
      commit("UNDO_RESPONSE");
    },

    updateAvatarId({ commit }, avatarId: number): void {
      commit("UPDATE_AVATAR_ID", avatarId);
    },

    updateAvatarList({ commit }, avatarList: IAvatar[]): void {
      commit("UPDATE_AVATAR_LIST", avatarList);
    },

    updateQuestions({ commit, state }, questions: IQuestion[]): void {
      commit("UPDATE_QUESTIONS", questions);
      if (state.deck.length <= 0) {
        if (CONFIG.SHUFFLE_DECK) {
          this.dispatch("shuffleDeck");
        } else {
          this.dispatch("populateDeck");
        }
      }
    }
  },

  getters: {
    CONFIG: (state): IConfig => state.CONFIG,
    avatar: (state): IAvatar | undefined => {
      return state.avatarList.find((avatar: IAvatar) => {
        return avatar.id === state.avatarId;
      });
    },
    avatarId: (state): number | null => state.avatarId,
    avatarList: (state): IAvatar[] => state.avatarList,
    currentQuestionIndex: (state): number => state.responses.length,
    deck: (state): IQuestion[] => state.deck,
    progress: (state): number => state.progress,
    questions: (state): IQuestion[] => state.questions,
    responses: (state): IResponse[] => state.responses
  },

  mutations: {
    ADD_RESPONSE(state, response: IResponse): void {
      state.responses.push(response);
    },

    DECREMENT_PROGRESS(state): void {
      state.progress -= state.unitProgress;
    },

    INCREMENT_PROGRESS(state): void {
      state.progress += state.unitProgress;
    },

    RESET_STATE(state): void {
      state.avatarId = null;
      state.progress = 0;
      state.responses = [];
    },

    UNDO_RESPONSE(state): void {
      state.responses.pop();
    },

    UPDATE_AVATAR_ID(state, avatarId): void {
      state.avatarId = avatarId;
    },

    UPDATE_AVATAR_LIST(state, avatarList: IAvatar[]): void {
      state.avatarList = avatarList;
    },

    UPDATE_DECK(state, questions: IQuestion[]): void {
      state.deck = questions;
    },

    UPDATE_QUESTIONS(state, questions: IQuestion[]): void {
      state.questions = questions;
    },

    UPDATE_UNIT_PROGRESS(state): void {
      // question length + avatar selection step
      state.unitProgress = 100 / (state.deck.length + 1);
    }
  },

  state: {
    CONFIG,
    avatarId: null as number | null,
    avatarList: [] as IAvatar[],
    deck: [] as IQuestion[],
    progress: 0,
    questions: [] as IQuestion[],
    responses: [] as IResponse[],
    unitProgress: 0
  }
});
